import React, { Component } from "react";
import FormsRow from "../components/FormsRow";
import DateInput from "../components/DateInput";
import TextInput from "../components/TextInput";
import SelectInput from "../components/SelectInput";

import DateTimeService from "../../../../utils/dateTimeService";

export default class PetrolRequestFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from_date: new DateTimeService(
        new DateTimeService().getPreviousMonthStartDate
      ).formatDate,
      to_date: new DateTimeService().todayDate,
      form_no: "",
      plate_number: "",
      vehicle_type: { value: undefined, label: "All" },
      employee_id: { value: undefined, label: "All" },
      region: { value: undefined, label: "All" },
      branch: { value: undefined, label: "All" },
      department: { value: undefined, label: "All" },
      position: { value: undefined, label: "All" },
    };
  }

  async componentDidMount() {
    this.handleSearch();
  }

  handleSearch = () => {
    const filters = this.props.isAllTab
      ? {
          ...this.state,
          employee_id: this.state.employee_id?.value,
          vehicle_type: this.state.vehicle_type?.value,
          region: this.state.region?.value,
          branch: this.state.branch?.value,
          department: this.state.department?.value,
          position: this.state.position?.value,
        }
      : {
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          form_no: this.state.form_no,
        };

    this.props.onClickSearch(filters);
  };

  handleInputChange = (value, inputKey) => {
    this.setState({
      [inputKey]: value,
    });
  };

  render() {
    const { isAllTab } = this.props;

    return (
      <div
        className="col-md-12"
        style={{
          paddingTop: 25,
          marginBottom: 35,
        }}
      >
        <FormsRow>
          <DateInput
            widthRatio={2}
            label="From Date"
            value={this.state.from_date}
            onChange={this.handleInputChange}
            inputKey="from_date"
          />
          <DateInput
            widthRatio={2}
            label="To Date"
            value={this.state.to_date}
            onChange={this.handleInputChange}
            inputKey="to_date"
          />
          <TextInput
            widthRatio={2}
            label="Requisition No."
            value={this.state.form_no}
            onChange={this.handleInputChange}
            inputKey="form_no"
            isNumber
          />
          {isAllTab && (
            <>
              <TextInput
                widthRatio={2}
                label="Plate Number"
                value={this.state.plate_number}
                onChange={this.handleInputChange}
                inputKey="plate_number"
              />
              <SelectInput
                widthRatio={3}
                label="Employee ID"
                value={this.state.employee_id}
                onChange={this.handleInputChange}
                inputKey="employee_id"
                options={this.props.employees}
                includeAllOption
              />
            </>
          )}

          {!isAllTab && <SearchButton handleSearch={this.handleSearch} />}
        </FormsRow>
        {isAllTab && (
          <FormsRow className="margin-top-20">
            <SelectInput
              widthRatio={2}
              label="Region"
              value={this.state.region}
              onChange={this.handleInputChange}
              inputKey="region"
              options={this.props.regions}
              includeAllOption
            />
            <SelectInput
              widthRatio={2}
              label="Branch"
              value={this.state.branch}
              onChange={this.handleInputChange}
              inputKey="branch"
              options={this.props.withdrawalLocations}
              includeAllOption
            />
            <SelectInput
              widthRatio={2}
              label="Department"
              value={this.state.department}
              onChange={this.handleInputChange}
              inputKey="department"
              options={this.props.departments}
              includeAllOption
            />
            <SelectInput
              widthRatio={2}
              label="Position"
              value={this.state.position}
              onChange={this.handleInputChange}
              inputKey="position"
              options={this.props.positions}
              includeAllOption
            />
            <SelectInput
              widthRatio={2}
              label="Vehicle Type"
              value={this.state.vehicle_type}
              onChange={this.handleInputChange}
              inputKey="vehicle_type"
              options={this.props.petrolVehicleTypes}
              includeAllOption
            />
            <SearchButton handleSearch={this.handleSearch} isAllTab />
          </FormsRow>
        )}
      </div>
    );
  }
}

class SearchButton extends Component {
  render() {
    const isAllTab = this.props.isAllTab ?? false;

    return (
      <div className={`col-md-${isAllTab ? 1 : 5} btn-rightend`}>
        <button
          className="btn-primary btn"
          onClick={this.props.handleSearch}
          style={{ marginTop: 20 }}
        >
          Search
        </button>
      </div>
    );
  }
}
